export default __webpack_public_path__ + "static/image_02-be3815835ce6eb013ff9fd3004a32302.png";